import {BusinessTransactionVolume, BusinessTransactionVolumeMapping} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableBusinessTransactionVolumeProps {
	transactionVolume?: BusinessTransactionVolume
	setTransactionVolume: (value: BusinessTransactionVolume) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: BusinessTransactionVolume) => void
	className?: string
}

export function EditableBusinessTransactionVolumeField(props: EditableBusinessTransactionVolumeProps) {
	if (props.transactionVolume) {
		return (
			<Editable
				label="Transaction Volume"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setTransactionVolume}
				value={props.transactionVolume}
				initial={props.transactionVolume}
				update={props.update}
				className={props.className}
				possibleValues={BusinessTransactionVolumeMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
